(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AccountClearingRequest', AccountClearingRequest);

    AccountClearingRequest.$inject = ['$resource', 'DateUtils'];

    function AccountClearingRequest($resource, DateUtils) {
        var resourceUrl = 'api/account-clearing-requests/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.toDate = DateUtils.convertDateTimeFromServer(data.toDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
